const _excluded = ["title", "body"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Typography } from 'seagull';
import styles from "./GraphWidgetSuccessState.module.scss";
export default function GraphWidgetSuccessState(props) {
  const {
      title,
      body
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: styles.root
  }), /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9996 24C39.9996 22.8954 40.8951 22 41.9996 22C43.1042 22 43.9996 22.8954 43.9996 24C43.9996 35.0457 35.0453 44 23.9996 44C18.7469 43.9877 13.713 41.8951 9.99963 38.18C6.25103 34.4516 4.13126 29.3906 4.10379 24.1036C4.04641 13.0581 12.9541 4.05738 23.9996 4C25.5957 4.00661 27.1859 4.19449 28.7396 4.56C28.8214 4.5745 28.9023 4.59408 28.9816 4.61863C30.0369 4.94503 30.6277 6.06507 30.3013 7.12031C29.9749 8.17555 28.8549 8.7664 27.7996 8.44C26.5527 8.15554 25.2785 8.008 23.9996 8C19.7391 7.9863 15.6522 9.68736 12.6596 12.72C9.68141 15.716 8.00889 19.7682 8.00696 23.9927C8.00292 32.8292 15.1631 39.996 23.9996 40C32.8362 40 39.9996 32.8366 39.9996 24ZM16.5796 22.58C17.3639 21.7958 18.6354 21.7958 19.4196 22.58L23.9996 27.08L36.4396 12.68C37.158 11.9321 38.3289 11.8573 39.1366 12.5079C39.9968 13.2007 40.1325 14.4598 39.4396 15.32L25.4396 31.32C25.0745 31.7362 24.5531 31.9824 23.9996 32C23.468 32.0031 22.9571 31.7944 22.5796 31.42L16.5796 25.42C15.7954 24.6358 15.7954 23.3642 16.5796 22.58Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, body));
}